import React from "react";
import { Card, CardContent } from "../../ui/card";

const StatCard = ({ title, value, subtitle, chart, icon }) => {
  // Clone the icon and force text-gray-400 and w-6 h-6
  const iconWithStyle = icon ? React.cloneElement(icon, { className: "w-6 h-6 text-gray-400" }) : null;
  return (
    <Card className="rounded-xl border border-gray-100 shadow-md bg-white w-full min-w-[120px] min-h-[120px] h-full flex flex-col items-center justify-center transition-transform duration-200 hover:shadow-md hover:scale-[1.03]">
      <CardContent className="flex flex-col items-center gap-2 h-full w-full p-4">
        {iconWithStyle && (
          <div className="w-9 h-9 rounded-full flex items-center justify-center bg-gray-100 mb-1 shadow-sm">
            {iconWithStyle}
          </div>
        )}
        <div className="text-xs text-gray-500 font-medium text-center mt-1">{title}</div>
        <div className="font-extrabold text-2xl text-black text-center my-1 leading-tight">{value}</div>
        {subtitle && (
          <span className="inline-block bg-gray-200 text-gray-700 text-xs font-medium px-2 py-0.5 rounded-full mt-0.5 mb-1">
            {subtitle}
          </span>
        )}
        {chart && <div className="mt-1 w-full">{chart}</div>}
      </CardContent>
    </Card>
  );
};

export default StatCard;